import { PlaceItem } from 'navigation'
import { walkTheStackDown } from 'state/reducers/navigation'

const placeBeforeModalNotWelcome = (ctx = { modal: false }) => (place: PlaceItem) => {
  if (!ctx.modal) {
    ctx.modal = place.modal
    return false
  }

  return !place.type.startsWith("home/welcome")
}

export const popModal = ({ stack }) => {
  const upIndex = walkTheStackDown(stack, placeBeforeModalNotWelcome())
  if (upIndex >= 0) {
    const up = stack[upIndex][0]
    return up
  } else {
    return stack[0][0]
  }
}
